import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/pages/Layout'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [{
        path: 'home',
        component: _ => import('@/pages/Home'),
        meta: {title: '主页 - 烛龙影视'}
      },
      {
        path: '/homepage/:id/yl',
        component: _ => import('@/pages/Home'),
        meta: {title: '主页 - 烛龙影视'}
      },
      {
        path: 'about-us',
        component: _ => import('@/pages/AboutUs'),
        meta: {title: '关于我们 - 烛龙影视', loading: true}
      },
      {
        path: 'about-us/:id/yl',
        component: _ => import('@/pages/AboutUs'),
        meta: {title: '关于我们 - 烛龙影视'}
      },
      {
        path: 'contactus/:id/yl',
        component: _ => import('@/pages/ContactUs'),
        meta: {title: '联系我们 - 烛龙影视', loading: true}
      },
      {
        path: 'contact-us',
        component: _ => import('@/pages/ContactUs'),
        meta: {title: '联系我们 - 烛龙影视', loading: true}
      },
      {
        path: 'company-news',
        component: _ => import('@/pages/CompanyNews'),
        meta: {title: '公司动态 - 烛龙影视'}
      },
      {
        path: 'live',
        component: _ => import('@/pages/Live'),
        meta: {title: 'Live - 烛龙影视'}
      },
      {
        path: 'live/:id/yl',
        component: _ => import('@/pages/Live'),
        meta: {title: 'Live - 烛龙影视'}
      },
      {
        path: 'news-detail/:id/:yl?',
        component: _ => import('@/pages/NewsDetail'),
        meta: {title: '动态 - 烛龙影视'}
      },
      {
        path: 'project-introduction',
        component: _ => import('@/pages/Projects'),
        meta: {title: '项目介绍 - 烛龙影视', loading: true}
      },
      {
        path: 'project-detail/:id',
        component: _ => import('@/pages/ProjectDetail'),
        meta: {title: '项目 - 烛龙影视'}
      },
      {
        path: 'projectintro/:pId/yl',
        component: _ => import('@/pages/ProjectDetail'),
        meta: {title: '项目 - 烛龙影视'}
      },
      {
        path: 'world-view',
        component: _ => import('@/pages/WorldView'),
        meta: {title: '世界观 - 烛龙影视', loading: true}
      },
      {
        path: 'worldview/:id/yl',
        component: _ => import('@/pages/WorldView'),
        meta: {title: '世界观 - 烛龙影视'}
      }
      ]
    },
    {
      path: '/*',
      component: _ => import('@/pages/404'),
      meta: {title: '404 - 烛龙影视'}
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  if (to.meta.loading) {
    store.commit('showLoading', true)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js